import { Component, OnInit } from '@angular/core';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { Promo } from 'src/app/assabil-sales/models/entities/promo-entity';
import { DateRangePipe } from 'src/app/tools/pipes/date-range-pipe';
import { PromoPipe } from 'src/app/assabil-sales/pipes/promo-pipe';
import { PromoLovComponent } from '../promo-lov/promo-lov.component';
import { Location } from '@angular/common';
import { Partner } from 'src/app/assabil-kernel/models/entities/master-data/partner-entity';
import { PartnerLovComponent } from 'src/app/assabil-admin/components/master-data/partner/partner-lov/partner-lov.component';
import { ProductPage } from 'src/app/assabil-kernel/models/entities/control-tables/product-page';
import { Sorder } from 'src/app/assabil-sales/models/entities/s-order';
import { SorderLine } from 'src/app/assabil-sales/models/entities/s-order-line';
import { Product } from 'src/app/assabil-kernel/models/entities/master-data/product-entity';
import { PromoService } from 'src/app/assabil-sales/services/pomo-service';
import { ToastrService } from 'ngx-toastr';
import { MasterDataService } from 'src/app/assabil-kernel/services/master-data-service';
import { SalesTransactionsService } from 'src/app/assabil-sales/services/sales-transactions-service';
import { MatDialog } from '@angular/material/dialog';
import { UserService } from 'src/app/assabil-kernel/services/user-service';

@Component({
  selector: 'promo-simulation',
  templateUrl: './promo-simulation.component.html',
  styleUrls: ['./promo-simulation.component.scss']
})
export class PromoSimulationComponent implements OnInit {

  promoPipe           : PromoPipe     = new PromoPipe();
  promos              : Promo[]       = [];
  simulationDate      : Date          = new Date();
  partner             : Partner       = new Partner();
  productPages        : ProductPage[] = [];
  sorder              : Sorder        = new Sorder();


  enteredOnly         : boolean       = false;
  qColumns  = [
    {'label' : 'Quantité',   readOnly : false, background :'#eef5fb'}, 
  ];

  partnerLovComponent = PartnerLovComponent;
  
  constructor(
    protected baseService     : BaseService,
    protected dialog          : MatDialog,
    protected masterDataService: MasterDataService,
    protected promoService    : PromoService,
    protected salesTransactionsService : SalesTransactionsService,
    protected location        : Location,
    protected toastr          : ToastrService,
    protected dateRangePipe   : DateRangePipe,
    protected userService     : UserService) {
    }

  listFields = [
    { prop: 'promoCode',       name: 'Code',                                         }, 
    { prop: 'name',            name: 'Nom'                                           },
    { prop: 'progressLevel',   name: 'Niv. Progression ',  pipe : this.promoPipe     }, 
    { prop: 'promo',           name: 'Dates',              pipe : this.dateRangePipe },
  //{ prop: 'status',          name: 'Satut ',             pipe : this.promoPipe     }, 
    { prop: 'basedOnBurned',   name: 'Basé/Brulé',        type : 'boolean'           }, 
    { prop: 'burningPromo',    name: 'Brulante',          type : 'boolean'           }, 
    { prop: 'sequence',        name: 'Sequence',                                     }, 
    { prop: 'skipToSequence',  name: 'Aller à',           pipe : this.promoPipe      }, 
    { prop: 'amount',          name: 'Montant',           pipe : this.promoPipe      }, 
  ]
      
//-----------------------------------------------------------------------------------------------------------------------------
productCode   : string;
salableOnly   : boolean = true;
includingHold : boolean = false;

ngOnInit() {
  this.masterDataService.loadProductPages(1, true).then(res => {
    this.productPages = this.masterDataService.salableProductPages;
  });
  /*
  this.masterDataService.productsGet(this.productCode, null, null, null, this.salableOnly, this.includingHold).then(products => {
    let productPage : ProductPage = new ProductPage();
    products.forEach( product => {
    if (product.productPage.productPageCode != productPage.productPageCode){
        productPage = product.productPage;
        productPage.expand = false;
        productPage.products = [];
        this.productPages.push(productPage);
    }
    productPage.products.push(product);
    })
});
*/
  }
//-----------------------------------------------------------------------------------------------------------------------------


//-----------------------------------------------------------------------------------------------------------------------------
promosLov : Promo[];
loadData(){
  let dialogRef = this.dialog.open(PromoLovComponent, {autoFocus: false,  hasBackdrop : false,  data : {dual : true, promos : this.promosLov}});
  dialogRef.afterClosed().subscribe(result => {
    if(result){
      this.promosLov = result.promos;
      if (result.selectedPromos) this.addPromos(result.selectedPromos);
    }
  });
}
//-----------------------------------------------------------------------------------------------------------------------------



  //-----------------------------------------------------------------------------------------------------------------------------
  addPromos(promos : Promo[]){
    for (let promo of promos){

      // Ignore partner if already exists in the list
      //-----------------------------------------------------------------------------
        let found : boolean = false;
        for (let p of this.promos){
          if (p.promoCode === promo.promoCode) {
            found = true;
            break
          }
        } 
        if (found){
          continue;
        }
        //-----------------------------------------------------------------------------

      this.promos.push(promo);
    }
    this.promos = [...this.promos];  
  }
//-----------------------------------------------------------------------------------------------------------------------------



//-----------------------------------------------------------------------------------------------------------------------------
simulate(){

  if (this.partner.partnerCode == null) {
    this.toastr.error("Priere de définir le client à considérer pour le test des promotions");
    return;
  }

  let sorder : Sorder = new Sorder();
  sorder.periodActiveDay = this.simulationDate;
  sorder.sorderLines = [];
  this.productPages.forEach(pp => {
      pp.products.forEach(p => {
        if (p.quantityP[0] == null)  p.quantityP[0] = 0;     // TODO
        if (p.quantityU[0] == null)  p.quantityU[0] = 0;
          if (p.quantityP[0] || p.quantityU[0]) {
              let sorderLine : SorderLine = new SorderLine();
              sorderLine.product = new Product();
              sorderLine.sorderLineNumber         = 0; // required, otherwise Json parsing pb on server side !!
              sorderLine.product.productCode      = p.productCode;
              sorderLine.product.name             = p.name;
              sorderLine.quantity                 = p.quantityP[0] * p.salesPacking +  p.quantityU[0] ;
              sorderLine.returnedQuantity         = 0;
              sorderLine.returnedDamagedQuantity1 = 0;
              sorderLine.returnedDamagedQuantity2 = 0; 
              sorderLine.unitPrice                = p.salesPrice;
              sorder.sorderLines.push(sorderLine);
          }
      })
  })
  let promoCodes : string[];

  if (this.promos.length != 0) {
    promoCodes = [];
    this.promos.forEach(promo => {
      promoCodes.push(promo.promoCode);
    })
  }

  this.salesTransactionsService.sorderSimulate(sorder, promoCodes).then(result => {
      this.sorder = result;

      this.promos.forEach( promo => {
        promo.amount = null;
      })

      if (this.sorder.salesTransactionPromoDetails) {
        for (let stpd of this.sorder.salesTransactionPromoDetails){
          for (let promo of this.promos){
              if (promo.promoCode == stpd.promoCode) {
                if ( promo.amount == null)  promo.amount = 0;
                promo.amount += stpd.discount;
              }
          }
        }
      }
      this.promos = [...this.promos];
  })
}
//-----------------------------------------------------------------------------------------------------------------------------

//-----------------------------------------------------------------------------------------------------------------------------
remove (promo : Promo){
  this.promos.splice(this.promos.indexOf(promo), 1);
  this.promos = [...this.promos];
}
//-----------------------------------------------------------------------------------------------------------------------------


//-----------------------------------------------------------------------------------------------------------------------------
 close(){
  this.location.back();
 }
//-----------------------------------------------------------------------------------------------------------------------------

}
